export class MESSAGES {
  public static readonly ERROR = {
    LOGIN: 'Authentication error, please check your credentials',
    GENERIC_REQUIRED: `The field is required`,
    PROJECT_NOT_SAVED: 'Error saving project, please try again',
    FORM_CONFIGURATION_INVALID: 'Invalid configuration. Fix before saving',
    FAILED_TO_DELETE: 'Failed to delete material, it is being used by the line(s): ',
    FILE_PARSE: 'Error parsing file. Please, verify and try again',
    INSERT_SEGMENT_DATA: 'Please, insert a valid segment data before selecting accessories',
    FIX_BEFORE_SAVING: 'Fix all errors before saving',
    MINIMUM_TABLE_SIZE: 'Reached the minimum size, you cannot delete anymore',
    MIN_TABLE_SIZE: 'Reached the minimum size of ',
    MAX_TABLE_SIZE: 'Reached maximum size of ',
    AUTOFIXED_RANGE: 'Automatically fixed range, the valid interval is between: ',
    SELECT_OBJECT: 'Error selecting object, please try again',
    LOADING: 'Error loading data',
    DOWNLOAD: 'Error downloading data',
    UPDATE: 'Failed to update simulation',
    OBJECT_TYPE_MISMATCH:
      'Type mismatch. Failed to find an object in current route. Object current config:',

    DATASHEET: {
      DELETING_HAS_CHILD: "Can't delete a datasheet containing revisions.",
      DELETING: 'Failed to delete.',
      DELETING_UNAUTHORIZED: 'You do not have permission to delete this datasheet.',
      EDITING_UNAUTHORIZED: 'You do not have permission to edit this datasheet.',
      DUPLICATING: 'Failed to duplicate datasheet.',
      CREATING_REVISION: 'Failed to create revision.',
      JSON_INCOMPATIBLE: 'This json file is incompatible',
    },

    CATENARY: {
      NO_CONVERGED: 'Convergence not achieved',
      SOME_NOT_CONVERGED: 'The following catenaries did not converge',
      NO_CONNECTION: 'There is no connection in the simulation',
      NO_MATERIAL: 'There is no material in the simulation',
      NO_LINE: 'There is no line in the simulation',
      ZERO_PROJECTION: 'There is a catenary with zero projection',
      SERVER_FAILED: 'Catenary Server failed',
    },
    REQUIRED: {
      GENERIC: `The field is required`,
      USER: 'The user field is required',
      PASSWORD: 'The password field is required',
    },
    INVALID: {
      GENERAL_INVALID: 'Please enter a valid',
      AT_LEAST_ZERO: 'must be at least zero',
      MAX_ONE: 'must be less than 1',
      MORE_THAN_ZERO: 'must be greater than zero',
      MORE_THAN: 'must be greater than',
      LESS_THAN: 'must be smaller than',
      BEG_POINT: 'Invalid beginning point',
      INTERVAL_BETWEEN_BEG_END: 'Invalid interval between beginning and end',
      INTERVAL: 'Invalid interval',
      END_POINT: 'Invalid end point',
      RANGE_BETWEEN_FIELDS: 'Invalid range between fields',
      LESS_THAN_OR_EQUAL_TO: 'must be smaller than or equal to',
    },
    ACCESSORIES: {
      FLOATER_DOESNT_FIT: "Your floater doesn't fit the segment.",
      POSITION_INTERFERENCE: 'There are interferences in the position of different accessories.',
      INTERNAL_INTERFERENCE: 'There are interferences between internal accessories positions.',
      DIAMETER_DOESNT_FIT: "Accessory's diameter doesn't fit the segment material.",
      LONGER_THAN_SEGMENT: 'Acessory is longer than segment.',
    },
    SHARE_UPDATE: 'Share update failed',
    USER: {
      DELETING: 'Failed deleting user.',
    },
    SIMULATION: {
      MISSING_SELECTION: 'Please, select the analysis case to run the simulation',
      VERIONS_NOT_FOUND: 'Not able to find available versions for execution',
      SIMULATION_FAILED: 'Simulation failed.',
      DOWNLOAD_FAILED: 'Failed to download artifacts',
      EXECUTION: 'Simulation request failed',
      ENVELOPES_EXECUTION: 'A Envelopes post processing request failed',
      TIME_SERIES_EXECUTION: 'A Time Series post processing request failed',
      FAD_FLEX_EXECUTION: 'A Fatigue Flexible post processing request failed',
      FAD_STEEL_EXECUTION: 'A Fatigue Steel post processing request failed',
    },
    CURRENT_POINTS: {
      SHOULD_GROW: 'Depth should be growing',
      DEEPER_THAN_GLOBAL: 'One or more points are too deep',
    },
    CONNECTOR_DELETED_BY_LINE:
      'A results connector was deleted to fit the new cross section configuration',
    EXPORT: 'Failed to export results. Error code:',
    RESULT_PLOT: {
      NO_MIN_RESULTS: 'Curve did not achieve the minimum amount of valid results',
      INVALID_RESULTS: 'Found invalid results in this curve',
      GENERIC_NO_MIN_RESULTS:
        'One or more curves did not achieve the minimum amount of valid results',
      GENERIC_INVALID_RESULTS: 'Invalid results were found',
    },
  } as const;

  public static readonly SUCCESS = {
    PROJECT: {
      CREATED: 'Project created successfully',
      SAVED: 'Project saved successfully',
    },
    SIMULATION: {
      LOADED: 'Simulation loaded successfully',
      EXECUTION: 'Simulation process was started successfully',
      ENVELOPES_EXECUTION:
        'A request for Envelopes post processing request was started successfully',
      TIME_SERIES_EXECUTION:
        'A request for Time Series post processing request was started successfully',
      FAD_FLEX_EXECUTION:
        'A request for Fatigue of Flexible Pipe post processing was started successfully',
      FAD_STEEL_EXECUTION:
        'A request for Fatigue of Steel Pipe post processing was started successfully',
      UPDATED: 'Simulation updated successfully',
    },
    DATASHEET: {
      DELETED: 'Datasheet deleted successfully',
      DUPLICATED: 'Datasheet duplicated successfully',
      REVISION_CREATED: 'Revision created successfully',
    },
    SHARE_UPDATE: 'Share update suceeded',
    EXPORT: 'Download of exported results started successfully',
  } as const;

  public static readonly WARNING = {
    CONNECTION_BEFORE_LINES: 'Please, configure Connections before Lines',
    LINES_BEFORE_RESULTS_OR_ANALYSIS: 'Please, configure Lines before Results or Analysis',
    CONNECTION_RESET_FOR_LINES: 'Some line connections were reset',
    SLOW_PROCESSING: 'The application is dealing with a long loading time. Please wait.',
    REGION_AUTO_FIX: 'The region end was reset to fit a single pipe of type',
    REGION_AUTO_FIX_BY_LINE: 'A results region end was reset to fit a single pipe type',
    REGION_AUTO_END_FIX: 'Final position was updated to be equal to initial',
    CONNECTOR_POSITION_AUTO_FIX:
      'The connector position was reset to fit the closest flexible pipe',
    FATIGUE_INSTRUCTION_CURVE_AUTO_DELETE:
      'The deleted curve was automatically removed from fatigue instructions',
    FATIGUE_NO_RESULT_TO_DOWNLOAD: 'There is no fatigue result to download',
    PASTE_WRONG_FORMAT: 'Some pasted content did not match the field requirements',
  } as const;

  public static readonly INFO = {
    NO_LAYERS: 'No layers found',
    NO_COF: 'Add a COF file in the respective cross section to enable fatigue configuration',
  } as const;

  public static readonly FRAES = {
    ERROR_LOADING_MATERIALS: 'Error loading material from FRAES',
    ERROR_LOADING_MATERIAL: 'Error loading material',
  } as const;
}
